export const teamlySocketUrl = `wss://team.notitia.world`;
export const teamlyHttpUrl = `https://team.notitia.world`;
